import PrivacyPolicyApp from "@/_roots/privacyPolicy/PrivacyPolicyApp.vue";
import VueInstance from "@/main";

VueInstance(PrivacyPolicyApp);
